import { useCurrentBoxId } from "@/modules/core/store/useCurrentSpaceManagerStore"
import { BoxDetailsEntity, BoxItemEntity } from "@modules/box/entities/boxEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"

export const useBoxs = () => {
  const { boxApi } = useServicesContext()

  const { data, isLoading, isRefetching } = useQuery({
    queryKey: ["boxs"],
    queryFn: async () => {
      const boxs = await boxApi.getBoxs()
      return boxs.map((box) => BoxItemEntity.fromDto(box))
    },
  })

  return {
    data: data ?? [],
    isLoading: isLoading,
    isRefetching: isRefetching,
  }
}

export const useBox = (id: string) => {
  const { boxApi } = useServicesContext()

  const { data, isLoading, isRefetching, error } = useQuery({
    queryKey: ["box", id],
    queryFn: async () => {
      const box = await boxApi.getBox(id)
      return BoxDetailsEntity.fromDto(box)
    },
  })

  return {
    result: data ?? null,
    isRefetching,
    isLoading,
    error,
  }
}

export const useCurrentBox = () => {
  const id = useCurrentBoxId()
  const { boxApi } = useServicesContext()
  const { data, isLoading, error } = useSuspenseQuery({
    queryKey: ["box", id],
    queryFn: async () => {
      if (id) {
        const box = await boxApi.getBox(id)
        return BoxDetailsEntity.fromDto(box)
      }
      return null
    },
  })

  return { result: data ?? null, isLoading, error }
}
